import styled from "styled-components";

export const Wrapper = styled.div`
  
`;

export const PageWrapper = styled.div`
  margin: 0px 20px;
  overflow-x: auto;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
`;
export const TabWrapper = styled.div`
  // width: fit-content;
  min-width: 10%;
  whitspace: nowrap;
  justify-content: center;
  height: 90%;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;
export const TabContainer = styled.div`
  display: flex;
  height: 90%;
  width: fit-content;
  whitespace: nowrap;
`;
